import React from "react";
import frame from "../../assets/images/Frame.png";
import email_icon from "../../assets/images/email.png";
import fb_icon from "../../assets/images/fb.png";
import insta_icon from "../../assets/images/insta.png";
import tweet_icon from "../../assets/images/tweeter.png";
import linkedin_icon from "../../assets/images/tweeter.png";
import ScrollAnimation from "react-animate-on-scroll";

function Footer(props) {
  return (
    <ScrollAnimation
      delay={500}
      animateIn="animate__slideInUp"
      animateOnce={true}
      className="col-12 px-0"
    >
      <footer className="bg-footer intro-y mt-4 mt-3 mt-md-4 row mx-auto">
        <div className="col-md-10 mx-auto mt-auto mb-3">
          <div className="row h-100">
            <div className="col-12 col-md-5 m-md-auto my-3">
              <h3 className="text-white">Contact Us</h3>
              <a className="" href="mailto:info@simplychartful.com">
                <div className="d-flex align-items-center text-white">
                  <i className="fa fa-envelope-o bg-white rounded-circle hover-shade sky mr-2 set-icon-email"></i>
                  <span className="text-shade">info@simplychartful.com</span>
                </div>
              </a>
              <div className="d-flex my-2">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  className="text-white mr-3"
                >
                  <i className="fa fa-lg fa-facebook border-white border rounded-circle hover-light-sky d-flex set-icon-fb"></i>
                  {/* <img src={fb_icon} alt="" /> */}
                </a>
                <a
                  href="https://pk.linkedin.com/"
                  target="_blank"
                  className="text-white mr-3"
                >
                  <i className="fa fa-lg fa-linkedin border-white border rounded-circle hover-light-sky d-flex set-icon-link"></i>
                  {/* <img src={linkedin_icon} alt="" /> */}
                </a>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  className="text-white mr-3"
                >
                  <i className="fa fa-lg fa-instagram border-white border rounded-circle hover-light-sky d-flex set-icon-insta"></i>
                  {/* <img src={insta_icon} alt="" /> */}
                </a>
                <a
                  href="https://twitter.com/?lang=en"
                  target="_blank"
                  className="text-white mr-3"
                >
                  <i className="fa fa-lg fa-twitter border-white border rounded-circle hover-light-sky d-flex set-icon-tweet"></i>
                  {/* <img src={tweet_icon} alt="" /> */}
                </a>
              </div>
            </div>
            <div className="col col-md-5 m-auto">
              <img className="w-100" src={frame} alt="" />
            </div>
          </div>
        </div>
        <div className="col-11 m-auto border-top">
          <p className="my-3 text-white text-center">
            <i className="fa fa-copyright pr-2"></i>
            Copyright 2021 Chartful. All Rights Reserved
          </p>
        </div>
      </footer>
    </ScrollAnimation>
  );
}

export default Footer;
